
export class CashPayment {

    amount : number = 0;
    type : string;
    refNo: string;
    fromLocationCode: number;
    location: any;
}
